import { render, staticRenderFns } from "./LiberacaoLaudo.vue?vue&type=template&id=07c3b95c&scoped=true&"
import script from "./LiberacaoLaudo.vue?vue&type=script&lang=js&"
export * from "./LiberacaoLaudo.vue?vue&type=script&lang=js&"
import style0 from "./LiberacaoLaudo.vue?vue&type=style&index=0&id=07c3b95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c3b95c",
  null
  
)

export default component.exports